module.exports = __webpack_public_path__ + "media/24.ebfe4240.mp3";